//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';

const JobTabRelatedTasks = () => {
  return <DataTableLayout tableKey="jobDetailTasks" simplified />;
};

export default JobTabRelatedTasks;
